import React from "react";
import PackagesTabsContainer from "../components/PackagesSections/PackagesTabsContainer";
import SectionTitle from "../components/Utilities/SectionTitle";

const PackagesLayout = () => {
  return (
    <>
      <section className="package-area section-gap">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <SectionTitle sectionTitleText="Packages" />
              <PackagesTabsContainer carousel={false} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PackagesLayout;
